module.exports = __webpack_public_path__ + "img/alisa.3bbc43b.png";